'use strict';

angular.module('app').run(function (Video) {}) // jshint ignore:line

.factory('Video', function (DS) {
    return DS.defineResource({
        name: 'Video',
        endpoint: 'videos',
        upsert: true
    });
});
